var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 907,
    viewBox: "0 0 683 907",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24701 244.664L507.798 -329.566C513.748 -336.338 524.915 -332.4 525.301 -323.395L535.743 -80.1576C535.857 -77.5095 534.915 -74.9245 533.123 -72.9707L239.508 247.269C235.697 251.427 236.076 257.913 240.346 261.598L683.521 644.061C685.257 645.559 686.426 647.609 686.831 649.866L730.659 894.23C732.345 903.627 721.162 909.817 714.094 903.399L4.03684 258.668C-0.00482992 254.998 -0.356412 248.765 3.24701 244.664Z",
    fill: "url(#paint0_linear_2900_1503)",
    fillOpacity: 0.06
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2900_1503",
    x1: 326.488,
    y1: -339.782,
    x2: 381.358,
    y2: 938.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#156CB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3DE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArr);
export default __webpack_public_path__ + "static/media/rightArr.c3dde215480dca59a123cb6309bc62f3.svg";
export { ForwardRef as ReactComponent };